// Customer reels: muted autoplay while visible, tap = sound, horizontal slider with arrows.
document.querySelectorAll('.kv-slider').forEach(slider => {
  if (slider.dataset.ready) return;
  slider.dataset.ready = 'true';
  const track = slider.querySelector('.kv-cards');
  const en = document.documentElement.lang.startsWith('en');
  const videos = [...track.querySelectorAll('video')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setSound = (video, on) => {
    video.muted = !on;
    const btn = video.parentElement.querySelector('[data-sound]');
    btn.setAttribute('aria-pressed', String(on));
    btn.setAttribute('aria-label', on ? (en ? 'Mute' : 'Couper le son') : (en ? 'Turn sound on' : 'Activer le son'));
  };
  const setPaused = (video, paused) => {
    const btn = video.parentElement.querySelector('[data-pause]');
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', paused ? (en ? 'Play' : 'Lecture') : 'Pause');
  };

  videos.forEach(video => {
    const media = video.parentElement;
    video.addEventListener('play', () => setPaused(video, false));
    video.addEventListener('pause', () => setPaused(video, true));
    video.addEventListener('contextmenu', e => e.preventDefault());
    media.querySelector('[data-pause]').addEventListener('click', e => {
      e.stopPropagation();
      video.dataset.userPaused = video.paused ? '' : 'true';
      video.paused ? video.play().catch(() => {}) : video.pause();
    });
    // Tap anywhere on the video (or the speaker) toggles sound; only one video speaks at a time.
    media.addEventListener('click', () => {
      const on = video.muted;
      videos.forEach(v => v !== video && setSound(v, false));
      setSound(video, on);
      if (on) { video.dataset.userPaused = ''; video.play().catch(() => {}); }
    });
  });

  // Posters only when the slider gets close: Shopify serves them as ~85 KB JPEGs to <video>,
  // and 4 of them loaded up front competed with the hero image on mobile.
  const posterIo = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return;
    videos.forEach(v => { v.poster = v.dataset.poster; });
    posterIo.disconnect();
  }, { rootMargin: '800px 0px' });
  posterIo.observe(slider);

  const io = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
    if (isIntersecting && !reduce && !target.dataset.userPaused) target.play().catch(() => {});
    else if (!isIntersecting) target.pause();
  }), { threshold: 0.6 });
  videos.forEach(v => { setPaused(v, true); io.observe(v); });

  const [prev, next] = slider.querySelectorAll('[data-dir]');
  const step = () => track.querySelector('.kv-card').offsetWidth + parseFloat(getComputedStyle(track).columnGap || 16);
  const update = () => {
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  [prev, next].forEach(btn => btn.addEventListener('click', () => track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: 'smooth' })));
  track.addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);
  update();
});
